<!-- App Shell Layout: Sidebar trái | (Navbar trên + Content dưới) -->
<div class="app-shell bg-[#f5f5f5]">

  <!-- SIDEBAR bên trái -->
  <aside class="app-shell__sidebar">
    <app-sidebar></app-sidebar>
  </aside>

  <!-- Cột phải: Navbar + Content -->
  <div class="app-shell__right">
    <header class="app-shell__navbar">
      <app-navbar></app-navbar>
    </header>

    <main class="app-shell__content">
      <router-outlet></router-outlet>
    </main>
  </div>

</div>
